import React, { useContext } from "react";
import styles from "./DmitrySchemeMini.module.scss";
import PathContext from "../../context/path";
const DmitrySchemeMini = () => {
  const path = useContext(PathContext);
  return (
    <>
      <div className={styles.wrap}>
        <div className={`${styles.part} ${styles.part_left}`}>
          <div className={styles.bg}>

            <picture>
              <source media="screen and (max-width: 767px)" srcSet={`${path}/img/scheme-dmitry-1-mobile.svg`} />
              <img src={`${path}/img/scheme-dmitry-1.svg`} alt="" />
            </picture>
          </div>
          <div className={styles.header}>
            <div className={styles.icon}>
              <svg width="51" height="51" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="25.5" cy="25.5" r="25.5" fill="#7E97F8" />
              </svg>
            </div>
            <div className={styles.text}>
              <p>Головная компания Р-Фарм спускает техническое задание: сколько, чего и как нужно произвести.</p>
            </div>
          </div>
        </div>
        <div className={`${styles.part} ${styles.part_right}`}>
          <div className={styles.header}>
            <div className={styles.icon}>
              <svg width="52" height="51" viewBox="0 0 52 51" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M25.9953 0L32.6269 6.09841L41.7654 4.87513L43.3548 13.5101L51.5 17.6206L47.451 25.5L51.5 33.3794L43.3548 37.4899L41.7654 46.1249L32.6269 44.9016L25.9953 51L19.3731 44.9016L10.2346 46.1249L8.64524 37.4899L0.5 33.3794L4.54897 25.5L0.5 17.6206L8.64524 13.5101L10.2346 4.87513L19.3731 6.09841L25.9953 0Z" fill="#7E97F8" />
              </svg>

            </div>
            <div className={styles.text}>
              <p>Я адаптирую документы, приземляю процесс на местное оборудование и площадку.</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );

}

export default DmitrySchemeMini;
